import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { AuthProfile, User } from "../../types/api/auth.type";
import { Role } from "../../types/AppTypes";
import { isDBLogin } from "../../utils/generals.utils";

export interface InitialStateProps {
  isAuthenticated: boolean;
  profile: AuthProfile;
  parentUser: User | null;
}

export const initialState: InitialStateProps = {
  isAuthenticated: !isDBLogin,
  profile: {
    id: -1,
    name: "",
    surname: "",
    isCm: false,
    role: Role.COLLABORATOR,
    enableImpersonate: false,
    restrictedCollaboratorIds: [],
    userPreferences: [],
  },
  parentUser: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setProfile: (
      state: InitialStateProps,
      action: PayloadAction<AuthProfile>,
    ) => {
      state.profile = action.payload;
    },
    setIsAuthenticated: (
      state: InitialStateProps,
      action: PayloadAction<boolean>,
    ) => {
      state.isAuthenticated = action.payload;
    },
    setParentUser: (
      state: InitialStateProps,
      action: PayloadAction<User | null>,
    ) => {
      state.parentUser = action.payload;
    },
    resetUserState: () => initialState,
  },
});

export const { setProfile, setIsAuthenticated, resetUserState, setParentUser } =
  userSlice.actions;
export default userSlice.reducer;
